import React from "react";
import {
  Box,
  Button,
  Col,
  Divider,
  Flex,
  Gap,
  InputField,
  Row,
  SelectField,
  Typography,
  Switchbox,
  Checkbox,
} from "../../ppui";
import { ContentHeading, ContentLayout, ContentBody } from "../style";
function OrganisationLeave() {
  return (
    <>
      <ContentLayout>
        <ContentHeading>
          <Typography variant="h5" mb="0">
            Leave Mnagement
          </Typography>
        </ContentHeading>
        <ContentBody Padding>
          <Typography variant="h5">Leave Information</Typography>
          <Row>
            <Col col-xs={"auto"}>
              <Row rowGap>
                <Col sm={12} md={6} lg={6} xxl={3}>
                  <SelectField
                    fullWidth
                    label="Leave Type"
                    name="leave_type"
                    options={[
                      { id: "option1", name: "Financial Year" },
                      { id: "option2", name: "Calender year" },
                    ]}
                    placeholder="Select Here..."
                  />
                </Col>
                <Col sm={12} md={6} lg={6} xxl={3}>
                  <InputField
                    fullWidth
                    label="Total leave"
                    name="total_leave"
                    type="text"
                    placeholder="Type Here..."
                    readOnly
                  />
                </Col>
                <Col sm={12} md={6} lg={6} xxl={3}>
                  <InputField
                    fullWidth
                    label="Casual leave"
                    name="casual_leave"
                    type="text"
                    placeholder="Type Here..."
                  />
                </Col>
                <Col sm={12} md={6} lg={6} xxl={3}>
                  <InputField
                    fullWidth
                    label="Medical leave"
                    name="medical_leave"
                    type="text"
                    placeholder="Type Here..."
                  />
                </Col>
                <Col sm={12} md={6} lg={6} xxl={3}>
                  <InputField
                    fullWidth
                    label="Privilege leave"
                    name="privilege_leave"
                    type="text"
                    placeholder="Type Here..."
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Divider gap={20} />

          <Flex justifyContent="space-between" mb={20}>
            <Box>
              <Typography variant="h5" mb={"0"}>
              Probation Period Leave
              </Typography>
            </Box>
            <Switchbox label="Disable" color="Primary" size="lg" lableFirst />
          </Flex>
          <Row>
            <Col col-xs={"auto"}>
              <Row rowGap>
                <Col sm={12} md={6} lg={6} xxl={3}>
                  <InputField
                    fullWidth
                    label="Medical leave"
                    name="medical_leave"
                    type="text"
                    placeholder="Type Here..."
                  />
                </Col>
                <Col sm={12} md={6} lg={6} xxl={3}>
                  <InputField
                    fullWidth
                    label="Casual leave"
                    name="casual_leave"
                    type="text"
                    placeholder="Type Here..."
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Divider gap={20} />

          <Flex justifyContent="space-between" mb={20}>
            <Box>
              <Typography variant="h5" mb={"0"}>
                Carry Forward Leave
              </Typography>
            </Box>
            <Switchbox label="Disable" color="Primary" size="lg" lableFirst />
          </Flex>
          <Row>
            <Col col-xs={"auto"}>
              <Row rowGap>
                <Col sm={12} md={6} lg={6} xxl={3}>
                  <InputField
                    fullWidth
                    label="Medical leave"
                    name="medical_leave"
                    type="text"
                    placeholder="Type Here..."
                  />
                </Col>
                <Col sm={12} md={6} lg={6} xxl={3}>
                  <InputField
                    fullWidth
                    label="Privilege leave"
                    name="privilege_leave"
                    type="text"
                    placeholder="Type Here..."
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Divider gap={20} />
          <Flex justifyContent="space-between" mb={20}>
            <Box>
              <Typography variant="h5" mb={"0"}>
                Earn Leave
              </Typography>
            </Box>
            <Switchbox label="Disable" color="Primary" size="lg" lableFirst />
          </Flex>
          <Row>
            <Col col-xs={"auto"}>
              <Row rowGap>
                <Col sm={12} md={6} lg={6} xxl={3}>
                  <InputField
                    fullWidth
                    label="Medical leave"
                    name="medical_leave"
                    type="text"
                    placeholder="Type Here..."
                  />
                </Col>
                <Col sm={12} md={6} lg={6} xxl={3}>
                  <InputField
                    fullWidth
                    label="Privilege leave"
                    name="privilege_leave"
                    type="text"
                    placeholder="Type Here..."
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Divider gap={20} />
          <Flex justifyContent="space-between" mb={18} gap={"10"}>
            <Typography variant="h5" mb={"0"}>
              Weekly Holiday
            </Typography>
            <Switchbox
              label="Payable Days"
              color="Primary"
              size="lg"
              lableFirst
            />
          </Flex>
          <Row rowGap mb={20}>
            <Col xs={"auto"}>
              <Checkbox color="primary" label={"Sunday"} />
            </Col>

            <Col xs={"auto"}>
              <Checkbox color="primary" label={"Monday"} />
            </Col>

            <Col xs={"auto"}>
              <Checkbox color="primary" label={"Tuesday"} />
            </Col>

            <Col xs={"auto"}>
              <Checkbox color="primary" label={"Wednesday"} />
            </Col>

            <Col xs={"auto"}>
              <Checkbox color="primary" label={"Thursday"} />
            </Col>

            <Col xs={"auto"}>
              <Checkbox color="primary" label={"Friday"} />
            </Col>

            <Col xs={"auto"}>
              <Checkbox color="primary" label={"Saturday"} />
            </Col>
          </Row>
          <Gap height={100} />
          <Flex justifyContent="flex-end" gap={"10"}>
            <Button onClick={() => {}} variant="outlined" disabled>
            Cancel
            </Button>
            <Button color="primary" onClick={() => {}} variant="contained">
              Save
            </Button>
          </Flex>
        </ContentBody>
      </ContentLayout>
    </>
  );
}

export default OrganisationLeave;
